// TODO: replace with src/components/ag-grid-cell-renderers/PrsUploadStatusCell/PrsUploadStatusCell?
import React, { useEffect, useState, memo } from "react"
import "./PRSUploadStatus.scss"

// helpers
import { capitalizeFirstLetter } from "../../utilities/misc"

const PRSUploadStatus = ({ data }) => {
  const [iconName, setIconName] = useState("")
  const [status, setStatus] = useState("Not Yet Started")

  const getColor = (variant) => {
    switch (variant) {
      case "Not Yet Started":
        return "prs-upload-not-started"
      case "Uploading":
        return "prs-upload-uploading "
      case "Failed":
        return "prs-upload-failed"
      case "Error":
        return "prs-upload-upload-error"
      case "Upload Cancelled":
        return "prs-upload-cancelled"
      default:
        return "prs-upload-default "
    }
  }

  useEffect(() => {
    if (data) {
      if (data.is_cancelled === true) {
        setStatus("Upload Cancelled")
      } else if (data.is_processing === true) {
        setStatus("Uploading")
      } else if (data.is_queued === true) {
        setStatus("Not Yet Started")
      } else if (data.upload_failed === true) {
        setStatus("Failed")
      } else if (data.upload_failed === false) {
        let { uploadStatus } = data.upload_report
        if (uploadStatus?.[0] === "CHANGED_STUDY" || uploadStatus === "CHANGED_STUDY") {
          setStatus("Changed Study")
        } else if (uploadStatus?.[1] === "UNCHANGED_STUDY" || uploadStatus === "UNCHANGED_STUDY") {
          setStatus("Unchanged Study")
        } else {
          setStatus("Uploaded")
        }
      } else if (data && data.upload_report && data.upload_report.uploadStatus) {
        let { uploadStatus } = data.upload_report
        if (uploadStatus && typeof uploadStatus === "string") {
          let title = uploadStatus
            .split("_")
            .map((word) => word.toLowerCase())
            .map((word) => capitalizeFirstLetter(word))
            .join(" ")
          setStatus(title)
        } else {
          setStatus("Failed")
        }
      }
    }
  }, [data])

  useEffect(() => {
    switch (status) {
      case "Uploading":
        setIconName("far fa-redo")
        break
      case "Not Yet Started":
        setIconName("fas fa-clock")
        break
      case "Failed":
        setIconName("fas fa-minus-circle")
        break
      case "Error":
        setIconName("fas fa-minus-circle")
        break
      case "Upload Cancelled":
        setIconName("far fa-ban")
        break
      default:
        setIconName("fas fa-check-circle")
    }
  }, [status])

  return (
    <div>
      <i
        className={`${iconName} ${getColor(status)} prs-upload-status-icon ${
          status === "Uploading" ? "prs-upload-animation-mixin" : "prs-upload-no-animation-mixin "
        }`}
      />
      {status}
    </div>
  )
}

export default memo(PRSUploadStatus)
